import React, { Fragment, useEffect, useRef } from "react";
import Breadcrumb from "../../component/common/breadcrumb/breadcrumb";
import { Container, Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import { useNavigate} from "react-router-dom";
import Swal from "sweetalert2";

const ActiveProcesses = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const cusId = localStorage.getItem("cusId");
    const tableRef = useRef(null);
    let dataTable;

    const handleRequestVehicle = async (id_valet, processId) => {
        const message = window.prompt("Ingrese un mensaje opcional para el valet:");
        if (message === null) return;

        const notificationData = {
            id_user: cusId,
            id_valet: id_valet,
            message: message || "",
            require_read: 1,
            process_id: processId,
            requested: 1,
        };

        try {
            await axios.post(`${process.env.REACT_APP_PUBLIC_SERVER}/api/notifications`, notificationData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success("Solicitud enviada al valet.");
            if (dataTable) {
                dataTable.ajax.reload(null, false);
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
            toast.error("Error al enviar la solicitud.");
        }
    };

    const handleRequestPayment = async (processId) => {
        const amountInput = window.prompt("Ingrese el monto de la propina (en PEN):");
        if (!amountInput || isNaN(amountInput) || parseFloat(amountInput) <= 0) {
            toast.error("Monto inválido.");
            return;
        }

        const amount = parseFloat(amountInput)*100;

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_PUBLIC_SERVER}/api/create-payment`,
                { amount, processId },
                { headers: { 'Content-Type': 'application/json' } }
            );

            const formToken = response.data;
            window.open(`/notifications?formToken=${formToken}`, '_blank', 'width=300,height=500');
        } catch (error) {
            console.error("Error al crear el pago:", error);
            toast.error("Error al crear el pago.");
        }
    };

    //modification of payment process
    const handlePayment = async (processId) => {
        const tip = "0";
        const { value:amountInput } = await Swal.fire({
            title: "Ingrese el monto de su propina",
            input: "text",
            inputLabel: "EJEMPLO DE MONTO A DEJAR DE PROPINA: 100",
            tip,
            showCancelButton: false,
            inputValidator: (value) => {
                if (!value) {
                    return "Necesita especificar un monto";
                }
            }
        });

        const amount = parseFloat(amountInput)*100;

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_PUBLIC_SERVER}/api/create-payment`,
                { amount, processId },
                { headers: { 'Content-Type': 'application/json' } }
            );

            const formToken = response.data;
            if(formToken)
            {
                Swal.fire({
                    title: '<strong>Realiza tu pago</strong>',
                    icon: 'info',
                    html:
                        '<iframe width="300" height="500" src="http://localhost:3000/notifications?formToken='+formToken+'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>',
                    showCloseButton: false,
                    showCancelButton: false,
                    focusConfirm: false,
                })
            }
            //window.open(`/notifications?formToken=${formToken}`, '_blank', 'width=300,height=500');
        } catch (error) {
            console.error("Error al crear el pago:", error);
            toast.error("Error al crear el pago.");
        }
    };

    useEffect(() => {
        if (cusId && token && tableRef.current) {
            dataTable = $(tableRef.current).DataTable({
                ajax: {
                    url: `${process.env.REACT_APP_PUBLIC_SERVER}/api/valet-process/active/${cusId}`,
                    type: "GET",
                    headers: { Authorization: `Bearer ${token}` },
                    dataSrc: "",
                },
                columns: [
                    { title: "ID", data: "id" },
                    { title: "Valet", data: "valet_name" },
                    { title: "Empresa", data: "company_name" },
                    {
                        title: "Fecha de inicio",
                        data: "created_at",
                        render: (data) => new Date(data).toLocaleString(),
                    },
                    { title: "Declaración de objetos", data: "object_declaration" },
                    { title: "GPS inicial", data: "initial_gps" },
                    {
                        title: "Acciones",
                        data: null,
                        render: (data, type, row) => {
                            if (row.requested) {
                                return `
                                    <span>Vehículo Solicitado</span>
                                    ${row.eta ? `<div>ETA: ${new Date(row.eta).toLocaleString()}</div>` : ""}
                                    <button class="btn btn-primary" onclick="window.handleRequestPayment('${row.id}')">
                                        Pagar Propina
                                    </button>
                                `;
                            } else {
                                return `
                                    <button class="btn btn-light" onclick="window.handleRequestVehicle('${row.id_valet}', '${row.id}')">
                                        <i class="fa fa-car"></i> Solicitar Vehículo
                                    </button>
                                `;
                            }
                        },
                    },
                ],
                responsive: true,
            });

            const intervalId = setInterval(() => {
                if (dataTable) {
                    dataTable.ajax.reload(null, false);
                }
            }, 30000);

            return () => {
                clearInterval(intervalId);
                if (dataTable) {
                    dataTable.destroy();
                }
            };
        }
        const handleMessage = (event) => {
            if (event.data.type === "paymentSuccess") {
                const processId = event.data.processId;
                window.open(`/payment-success?processId=${processId}`, '_blank', 'width=500,height=400');
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [cusId, token]);

    window.handleRequestVehicle = handleRequestVehicle;
    window.handleRequestPayment = handlePayment;

    return (
        <Fragment>
            <Breadcrumb parent="Dashboard" title="Procesos Activos" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Procesos de Valet Activos</h5>
                            </CardHeader>
                            <CardBody>
                                <table ref={tableRef} className="table table-striped nowrap" style={{ width: "100%" }}></table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default ActiveProcesses;
